//@ts-ignore
import { tw } from "@careinfo/tailwind";
import React, { Dispatch, SetStateAction } from "react";

import {
  Button,
  Dialog,
  Heading,
  Modal,
  ModalOverlay,
} from "react-aria-components";
import "./style.css";
interface Props {
  isOpen: boolean;
  children: React.ReactNode;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  onClose?: () => void;
  title?: string;
  width?: string;
}

const PopupModal = ({ isOpen, setIsOpen, children, title, onClose }: Props) => {
  function closeModal() {
    return onClose ? onClose() : setIsOpen(false);
  }

  return (
    <>
      <Modal isDismissable isOpen={isOpen} onOpenChange={setIsOpen}>
        <Dialog
          className={tw`w-fit focus:outline-none min-h-[300px] max-w-4xl transform  rounded-2xl bg-white p-6 text-left align-middle shadow-xl `}
        >
          <div className={tw`flex items-center justify-between`}>
            <Heading slot="title" className={tw`font-semibold text-lg`}>
              {title}
            </Heading>
            <Button
              slot="close"
              onPress={closeModal}
              className={"focus:outline-none"}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 6L6 18M6 6L18 18"
                  stroke="#0D0D0D"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </Button>
          </div>
          {children}
        </Dialog>
      </Modal>
    </>
  );
};

export default PopupModal;
